import '../lib/classList';

const rafPolyfill = () =>{
    if (typeof window['requestAnimationFrame'] === 'undefined') {
        window.requestAnimationFrame = setTimeout;
    }

    // closest() polyfill
    if(!Element.prototype.matches){
        Element.prototype.matches = Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;
    }

    if(!Element.prototype.closest){
        Element.prototype.closest = function(selector) {
            var element = this;

            if(!document.documentElement.contains(element)){
                return null;
            }

            do{
                if(element.matches(selector)){
                    return element;
                }

                element = element.parentElement || element.parentNode;
            } while (element !== null && element.nodeType === 1);

            return null;
        };
    }

    // Number.isNaN() polyfill
    Number.isNaN = Number.isNaN || function(value) {
        return value !== value;
    }
};

const loadPolyEventForIE = () =>{
    if ( typeof window.CustomEvent === "function" ) return false;

    function CustomEvent ( event, params ) {
        params = params || { bubbles: false, cancelable: false, detail: null };
        var evt = document.createEvent( 'CustomEvent' );
        evt.initCustomEvent( event, params.bubbles, params.cancelable, params.detail );
        return evt;
    }

    CustomEvent.prototype = window.Event.prototype;

    window.CustomEvent = CustomEvent;
};

export const loadPolyfills = () =>{
    rafPolyfill();
    loadPolyEventForIE();
};


// WEBPACK FOOTER //
// ./src/js/utils/polyfills.js